import { toRaw } from "vue";

function unwrap(value, seen = new WeakMap()) {
  if (value === null || typeof value !== "object") return value;
  if (value instanceof Date) return new Date(value.getTime());
  if (typeof value.toDate === "function")
    try {
      return value.toDate();
    } catch { /* fallthrough */ }


  const raw = toRaw(value);
  if (seen.has(raw)) return seen.get(raw);

  if (Array.isArray(raw)) {
    const arr = [];
    seen.set(raw, arr);
    for (const item of raw) arr.push(unwrap(item, seen));
    return arr;
  }

  const out = {};
  seen.set(raw, out);
  for (const key of Object.keys(raw)) out[key] = unwrap(raw[key], seen);
  return out;
}

export function cloneDeep(value) {
  if (value === null || typeof value !== "object") return value;
  try {
    return structuredClone(unwrap(value));
  } catch {
    return unwrap(value);
  }
}
